import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { environment } from '../../environments/environment';
import { User } from './user';
import { parseErrors } from '../shared/api.service';

const camelcaseKeysDeep = require('camelcase-keys-deep');
const decamelizeKeysDeep = require('decamelize-keys-deep');

@Injectable()
export class UserService {
  baseUrl = environment.serverUrl;

  constructor(private http: Http) { }

  private extractData(res: Response) {
    let body = res.json().results;
    if (body) {
      return body.map(user => {
        user = camelcaseKeysDeep(user);
        return new User(user);
      });
    } else if (res.json()) {
      let user = camelcaseKeysDeep(res.json());
      return new User(user);
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/users/user.service.ts